import VueRouter from 'vue-router';
import Dashboard from './views/pages/Dashboard.vue';
import Sync from "./views/pages/Sync.vue";

Vue.use(VueRouter);

let routes = [
    {
        path: '/',
        component: Dashboard,
        meta: {
            title: "dashboard",
        },
        alias: '/home'
    }
];


routes = Vue.cmsRouter.setRoutes(routes);

routes.find(route => route.name === 'grid').children.push({
    path: 'sync',
    name: 'sync',
    components: {
        childview: Sync
    }
})

const router = new VueRouter({
    routes
})

Vue.cmsRouter.setActiveRouter(router);

export default router;
